import { useGlobalState } from 'state/globalState'
import { Navigate, Outlet } from 'react-router-dom'

export const DataReadyRoute = () => {
  const { user } = useGlobalState();

  return user?.org_is_data_ready ? <Outlet /> : <Navigate to="/welcome" />
}
